<template>
  <div class="adminHome tableloding" v-loading="loadingMydevice">
    <!-- :deviceList="deviceList" -->
    <!-- <div>{{deviceInfo}}</div> -->
    <device-nav v-if="showSidebar"></device-nav>
    <component :is="shownComponent" v-if="shownComponent" class="article"></component>

    <!-- 新增数采器 -->
    <datalogger-dialog :visible.sync="dialogDataloggerVisible" v-if="dialogDataloggerVisible"
      @submitSucAdd="handleCreateSuc" @submitFailAdd="handleCreateFail"></datalogger-dialog>
    <!-- 添加结果提示(成功) -->
    <!-- v-if="dataloggerAddSucVisible" -->
    <device-dialog :title="$t('datalogger.addResults')" :visible.sync="dataloggerAddSucVisible"
      :class="{ 'showDialog': dataloggerAddSucVisible, 'hideDialog': !dataloggerAddSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.addedSuccessfully') }}</span>
          <!-- <span class="showresulttext">{{dataloggerTipMsg}}</span> -->
          <div class="showoperate">
            <!-- 继续添加 -->
            <button type="button" class="btn btn-light" style="margin-right:10px;"
              @click="dataloggerAddSucVisible = false; dialogDataloggerVisible = true;">{{ $t('datalogger.continueAdding') }}</button>
            <!-- 完成 -->
            <button type="button" class="btn btn-dark"
              @click="dataloggerAddSucVisible = false;">{{ $t('datalogger.finish') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 添加结果提示(失败) -->
    <!-- v-if="dataloggerAddFailVisible" -->
    <device-dialog :title="$t('datalogger.addResults')" :visible.sync="dataloggerAddFailVisible"
      :class="{ 'showDialog': dataloggerAddFailVisible, 'hideDialog': !dataloggerAddFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ dataloggerTipMsg }}</span>
          <div class="showoperate">
            <!-- 暂不添加 -->
            <button type="button" class="btn btn-light" style="margin-right:10px;"
              @click="dataloggerAddFailVisible = false;">{{ $t('datalogger.nowNoAdd') }}</button>
            <!-- 重新添加 -->
            <button type="button" class="btn btn-dark"
              @click="dataloggerAddFailVisible = false; dialogDataloggerVisible = true;">{{ $t('datalogger.reAdd') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
// import deviceNav from './sidebar'
import deviceNav from './sidebarmodenew'
// import deviceOverview from './overview'
import deviceDetail from './detail'
import deviceNo from './deviceno'
import { mapGetters } from 'vuex'
import deviceDialog from "@/components/dialognew";
import dataloggerDialog from "@/components/dialognew/dataloggernew";
export default {
  components: {
    deviceNav,
    // deviceOverview,
    deviceDetail,
    deviceNo,
    deviceDialog,
    dataloggerDialog
  },
  data () {
    return {
      // overview: 设备列表; detail: 设备详情
      shownComponent: null,
      // 设备列表
      deviceList: [],
      // 添加数采器弹窗
      dialogDataloggerVisible: false,
      // 添加成功提示弹窗
      dataloggerAddSucVisible: false,
      // 添加失败提示弹窗
      dataloggerAddFailVisible: false,
      // 操作返回提示
      dataloggerTipMsg: '',
      // 显示侧边栏
      showSidebar: false,
      // Loading
      loadingMydevice: false,
      // 分页数据
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      },
      // 数采器管理点击设备跳转本页
      redirectDevice: null,
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
  },
  watch: {
    deviceInfo: {
      handler (val) {
        // console.log('deviceInfo', val)
        if (val.pn) {
          this.showSidebar = true
          this.shownComponent = 'deviceDetail'
        } else {
          this.showSidebar = false
          // this.shownComponent = 'deviceOverview'
          // 空设备
          // this.shownComponent = 'deviceNo'
          this.$router.push({ path: '/generalNew/deviceno' })
        }
      },
      deep: true
    },
    // 响应更新电站列表事件
    '$store.state.event.updateDeviceList' (val) {
      if (val) {
        this.queryDeviceList(true)
        this.$store.state.event.updateDeviceList = false
      }
    }
  },
  created () {
    // if(this.deviceInfo.pn) {
    //   this.showSidebar = false
    //   // this.shownComponent = 'deviceOverview'
    //   // 空设备
    //   // this.shownComponent = 'deviceNo'
    //   this.$router.push({path:'/generalNew/deviceno'})
    // }

    // 数采器管理点击设备跳转本页
    if (this.$route.query.tool && this.$route.query.tool.curDeviceInfo) {
      // console.log('scq->sb:info', this.$route.query.tool.curDeviceInfo);
      this.redirectDevice = this.$route.query.tool.curDeviceInfo;
      // this.$store.commit("saveDeviceInfo", this.$route.query.tool.curDeviceInfo);
      window.location.href = this.delurlquery(window.location.href, "tool");
    }

    this.queryDeviceList()
    // 数采器管理页添加数采器回我的设备页通知
    if (this.$route.query.tool) {
      this.isNotice = this.$route.query.tool.notice;
    }
    if (this.isNotice == 'Suc') {
      // console.log('我的设备页=>添加成功回调');
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      window.location.href = this.delurlquery(window.location.href, "tool");
      // window.location.reload();
      setTimeout(() => {
        this.handleCreateSuc();
      }, 0)
    } else if (this.isNotice == 'Fail') {
      // console.log('我的设备页=>添加失败回调');
      this.handleCreateFail(this.isVal);
      window.location.href = this.delurlquery(window.location.href, "tool");
    }
  },
  beforeDestroy () {
    this.$store.commit('saveDeviceInfo', {
      sn: null,
      deviceSn: null
    })
  },
  methods: {
    // 辅助传参=删url指定query
    delurlquery (url, key) {
      // console.log(url, key,"11111111111111")
      key = this.escapereg(key);
      // console.log(key,"11111111111111")
      var reg = new RegExp("((\\?)(" + key + "=[^&]*&)+(?!" + key + "=))|(((\\?|&)" + key + "=[^&]*)+$)|(&" + key + "=[^&]*)", "g");
      return url.replace(reg, "\x241")
    },
    // 辅助传参=拼正则表达式字符串时消除原字符串中特殊字符干扰
    escapereg (str) {
      return str.replace(new RegExp("([.*+?^=!:${}()[\\]\\\\])", "g"), "\\$1");
    },
    // 添加数采器成功回调
    handleCreateSuc () {
      this.dataloggerAddSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      // 刷新本页
      // window.location.reload();
    },
    // 添加数采器失败回调
    handleCreateFail (val) {
      this.dataloggerTipMsg = val;
      this.dataloggerAddFailVisible = true;
    },
    // 查询用户设备列表
    // queryDeviceList (noRefresh) {
    //   let param = {
    //     devtype: 2304,
    //     pagesize: 500
    //   }
    //   this.loadingMydevice = true;
    //   this.$request.get('webQueryDeviceEs', param).then(res => {
    //     if(res.err === 0) {
    //       this.deviceList = res.dat.device

    //       let devcode = this.$route.query.devcode, pn = this.$route.query.pn, devaddr = this.$route.query.devaddr, sn = this.$route.query.sn
    //       let selectedDevice = this.deviceList.find(item => {
    //           return item.devcode == devcode && item.pn == pn && item.devaddr == devaddr && item.sn == sn
    //         })
    //       if (!noRefresh) {
    //         if (sn && selectedDevice) {
    //           // Loading 
    //           this.loadingMydevice = false;
    //           this.$store.commit('saveDeviceInfo', selectedDevice)
    //           return
    //         } else if (this.deviceList.length) {
    //           // Loading
    //           this.loadingMydevice = false;
    //           this.$store.commit('saveDeviceInfo', this.deviceList[0])
    //           return
    //         }
    //       }
    //     }
    //     this.$store.commit('saveDeviceInfo', {pn:'',sn:'',devcode:'',devaddr:''});
    //     // this.loadingMydevice = false;
    //   })
    // },
    queryDeviceList (reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // ...this.search,
        devtype: 2304,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pagesize
      };
      this.loadingMydevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0 && Array.isArray(res.data && res.data.items) && res.data.items.length > 0) {
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceList = this.Fnreturndev(res);

          // 保存列表中首个设备信息到store中(deviceSn缺省时回退用sn)
          this.$store.commit('saveDeviceInfo', { ...this.deviceList[0], deviceSn: this.deviceList[0].deviceSn || this.deviceList[0].sn });
          // 存在数采器管理点击设备跳转本页时
          if (this.redirectDevice) {
            this.$store.commit('saveDeviceInfo', { ...this.redirectDevice, deviceSn: this.redirectDevice.deviceSn || this.redirectDevice.sn });
          }

          this.pagination.total = res.data.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.deviceList = [];
          this.pagination.total = 0;

          // console.log("deviceIndexInitFail");
          // 跳转空页
          this.$router.push({ path: '/generalNew/deviceno' });
        }
        this.loadingMydevice = false;
      });
    },
  }
}
</script>
<style lang="less" scoped>
.adminHome {
  flex: 1;
  display: flex;
  align-items: stretch;
  background: #f0f0f0;

  // 统一按钮
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .article {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  &.tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // .el-loading-spinner i {
    //   color: @primaryTextColor;
    // }
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
